/**
 * Smooth scroll component
 * Handles smooth scrolling for anchor links
 */

function initSmoothScroll() {
    // Get all anchor links that start with #
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', handleSmoothScroll);
    });
}

/**
 * Handle smooth scroll to target element
 * @param {Event} event - Click event
 */
function handleSmoothScroll(event) {
    // Get the href attribute
    const href = event.currentTarget.getAttribute('href');
    
    // Skip if href is just #
    if (href === '#') {
        return;
    }
    
    // Only handle anchor links (href starting with #)
    // If href was changed to external URL, let browser handle it normally
    if (!href || !href.startsWith('#')) {
        return;
    }
    
    // Prevent default anchor behavior
    event.preventDefault();
    
    // Get the target element
    const targetElement = document.querySelector(href);
    
    if (!targetElement) {
        console.warn(`Target element ${href} not found`);
        return;
    }
    
    // Calculate offset (accounting for fixed header)
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
    
    // Smooth scroll to target
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
    
    // Update URL hash without jumping
    if (history.pushState) {
        history.pushState(null, null, href);
    } else {
        window.location.hash = href;
    }
    
    // Focus on target element for accessibility
    targetElement.setAttribute('tabindex', '-1');
    targetElement.focus();
    
    // Remove tabindex after focus
    targetElement.addEventListener('blur', () => {
        targetElement.removeAttribute('tabindex');
    }, { once: true });
}

/**
 * Scroll to element on page load if hash exists
 */
function scrollToHashOnLoad() {
    if (window.location.hash) {
        // Wait for page to fully load
        window.addEventListener('load', () => {
            setTimeout(() => {
                const targetElement = document.querySelector(window.location.hash);
                
                if (targetElement) {
                    const header = document.querySelector('.header');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        });
    }
}

// Expose to global for concatenated builds
window.initSmoothScroll = initSmoothScroll;
window.scrollToHashOnLoad = scrollToHashOnLoad;